<template>
  <hm-content title="编辑排班"> </hm-content>
</template>

<script>
 import { mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: mapGetters(["storeList", "staffList"]),
  created() {},
  mounted() {
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
  },
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss"></style>
